// TS types
import { TTripType, IfetchDetailData, IalreadyFetchedMonth } from '@redux/common';

// common function
import getEnvConfig from '@api/config';
import { getLowestPriceSession, handletBodyFixed, getEarliestDate, getAllDatesInDetailData } from './core';

// plugin
import dayjs from 'dayjs';

// redux actions
import {
    setTHSRInitData,
    setTHSRDetailData,
    setTHSRStations,
    setTHSRDetailLoading,
    setTHSRInfo,
    setTHSRIsInitFail,
} from '@redux/THSR/actions';
import { setIsGDSSessionLoading } from '@redux/GDS/actions'; 

interface ISetGDSSessionData {
    date: string;
    FormatID: string;
    ETID?: string;
    context: {
        setGSessionLoading: any;
        setGSessionFetchFail: any;
        setSession: any;
        setSessionPicked: any;
    };
    dispatch: any;
}
interface IfetchGDSDetailData {
    ETID: string;
    EarliestBuyDay: string;
    ExpectedUseDay: boolean;
    FormatID: string;
    isTHSR: boolean;
    context: {
        GDetailStore: any;
        setGDSDetailFetchFail: any;
        setDetailFetchFailMsg: any;
        setGDetail: any;
        setGTempCalendarData: any;
        setIsGDSDetailLoading: any;
        setGDetailStore: any;
        setSession: any;
        setSessionPicked: any;
        setGSessionLoading: any;
        setGSessionFetchFail: any;
        setCalendar?:any;
        ThsrRoundType?:any;
    };
    dispatch?: any;
}

interface ISetTHSRInit {
    ETID: string;
}
interface ISetTHSRDetail {
    signal?: AbortSignal;
    context?: any;
    req?: any;
}

//取得高鐵基礎資訊
export const setTHSRInit =
    ({ ETID }: ISetTHSRInit) =>
    (dispatch) => {
        const InitTHSR = getEnvConfig().THSR.init;
        try {
            const config = {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                }),
            };

            const source = InitTHSR + `?ProductNo=${ETID}`;

            fetch(source, config)
                .then((res) => res.json())
                .then((data) => {
                    dispatch(setTHSRInitData({ ...data }));
                })
                .catch((error) => {
                    dispatch(setTHSRIsInitFail(true));
                    console.error('fetchTHSRinitDataError:', error);
                });
        } catch (e) {
            console.log('error msg', e);
        }
    };
export const getTHSRStations = () => (dispatch) => {
    const fetchUrl = getEnvConfig().THSR.stations;
    const config = {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
    };
    const source = fetchUrl;
    fetch(source, config)
        .then((res) => res.json())
        .then((data) => {
            dispatch(setTHSRStations(data));
        })
        .catch((error) => {
            console.error('fetchTHSRstations:', error);
            dispatch(setTHSRIsInitFail(true));
        });
};
//高鐵聯票 搜尋班次
export const getTHSRDetail = ({ signal, req }: ISetTHSRDetail) => {
    //座位數加總
    let req_sumSeat = 0;
    Object.keys(req.seatInfo).forEach((child) => {
        req_sumSeat += req.seatInfo[child];
    });
    const reqBody =
        req.THSRType === TTripType.oneway
            ? {
                  RoundStations: req.departure + '-' + req.destination,
                  RoundDateTime: req.startDate + '_' + req.startTime,
                  Passenger: req_sumSeat,
                  TrainClass: req.seatClass,
                  Etcode: req.Etcode,
              }
            : {
                  RoundStations:
                      req.departure +
                      '-' +
                      req.destination +
                      ',' +
                      req.destination +
                      '-' +
                      req.departure,
                  RoundDateTime:
                      req.startDate + '_' + req.startTime + ',' + req.endDate + '_' + req.endTime,
                  Passenger: req_sumSeat,
                  TrainClass: req.seatClass,
                  Etcode: req.Etcode,
              };
    // console.log('reqBody in getTHSRDetail', reqBody);
    const config = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        signal: signal,
        body: JSON.stringify(reqBody),
    };
    const source = getEnvConfig().THSR.detail;
    return fetch(source, config)
        .then((res) => res.json())
        .then((data) => {
            //只抓前5筆的班次回來
            if (data.Rounds) {
                data.Rounds.forEach((element, i) => {
                    if (element.TrainItems.length > 5) {
                        data.Rounds[i].TrainItems = element.TrainItems.slice(0, 5);
                    }
                });
            }
            //南港、台北、板橋不賣商務艙，但API回來的仍然有資料，因此dispatch時要注意
            //前台會依據NoBusinessClass這個字串做判斷，所以不要改
            if (
                ['NAK', 'TPE', 'BAC'].includes(req.departure) &&
                ['NAK', 'TPE', 'BAC'].includes(req.destination) &&
                req.seatClass === 'J'
            ) {
                delete data.Rounds;
                data.error = 'NoBusinessClass';
            }

            return data;
        })
        .catch((err) => {
            return { error: '服務異常，請再試試看' };
        });
};
//高鐵聯票 搜尋更早更晚的班次
export const getTHSROtherTimeDetail = ({ signal, req }: ISetTHSRDetail) => {
    //座位數加總
    let req_sumSeat = 0;
    Object.keys(req.seatInfo).forEach((child) => {
        req_sumSeat += req.seatInfo[child];
    });
    //req.direction為去回程 0為去程
    const reqBody =
        req.direction === 0
            ? {
                  RoundStations: req.departure + '-' + req.destination,
                  RoundDateTime: req.startDate + '_' + req.startTime,
                  Passenger: req_sumSeat,
                  TrainClass: req.seatClass,
                  Etcode: req.Etcode,
              }
            : {
                  RoundStations: req.destination + '-' + req.departure,
                  RoundDateTime: req.endDate + '_' + req.endTime,
                  Passenger: req_sumSeat,
                  TrainClass: req.seatClass,
                  Etcode: req.Etcode,
              };

    const config = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        signal: signal,
        body: JSON.stringify(reqBody),
    };
    const source = getEnvConfig().THSR.detail;
    return fetch(source, config)
        .then((res) => res.json())
        .then((data) => {
            //只抓前5筆的班次回來
            if (data.Rounds) {
                data.Rounds.forEach((element, i) => {
                    if (element.TrainItems.length > 5) {
                        data.Rounds[i].TrainItems = element.TrainItems.slice(0, 5);
                    }
                });
            }
            return data;
        })
        .catch((err) => {
            return { error: '服務異常，請再試試看' };
        });
};
/*
    req=[
        {
            "DepartStation":"TPE",
            "ArriveStation":"ZUY",
            "DepartDate":"2022-03-28",
            "DepartTime": "0811",
            "Passenger": 3,
            "TrainClass":"Y",
            "TrainNumber":"0809"
        },
        {
            "DepartStation":"ZUY",
            "ArriveStation":"TPE",
            "DepartDate":"2022-03-29",
            "DepartTime": "0755",
            "Passenger": 3,
            "TrainClass":"Y",
            "TrainNumber":"0108"
        }
    ]
*/

//高鐵聯票 班次庫存檢查
export const getCheckThsrQty = ({ signal, req }: ISetTHSRDetail) => {
    const config = {
        method: 'POST',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
        signal: signal,
        body: JSON.stringify(req),
    };
    const source = getEnvConfig().THSR.CheckThsrQty;
    return fetch(source, config)
        .then((res) => res.json())
        .then((data) => {
            return data;
        })
        .catch((err) => {
            return { error: '服務異常，請再試試看' };
        });
};

export const getTHSRInfo = ({ signal, req }: ISetTHSRDetail) => (
    (dispatch) => {
        //愛心票加總
        let req_sumCntC = 0;
        ['E', 'W', 'H'].forEach((child) => {
            req_sumCntC += req.seatInfo[child] || 0;
        });
        const reqBody =
            req.THSRType === TTripType.oneway
                ? [
                    {
                        Date: dayjs(req.startDate).format('YYYYMMDD'),
                        FStation: req.departure,
                        TStation: req.destination,
                        Type: req.seatClass,
                        CntA: req.seatInfo.F || 0,
                        CntC: req_sumCntC,
                        Etcode: req.Etcode,
                    },
                ]
                : [
                    {
                        Date: dayjs(req.startDate).format('YYYYMMDD'),
                        FStation: req.departure,
                        TStation: req.destination,
                        Type: req.seatClass,
                        CntA: req.seatInfo.F || 0,
                        CntC: req_sumCntC,
                        Etcode: req.Etcode,
                    },
                    {
                        Date: dayjs(req.endDate).format('YYYYMMDD'),
                        FStation: req.destination,
                        TStation: req.departure,
                        Type: req.seatClass,
                        CntA: req.seatInfo.F || 0,
                        CntC: req_sumCntC,
                        Etcode: req.Etcode,
                    },
                ];

        const config = {
            method: 'POST',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
            body: JSON.stringify(reqBody),
        };
        const source = getEnvConfig().THSR.info;
        return fetch(source, config)
            .then((res) => res.json())
            .then((data) => {
                return data;
            })
            .catch((err) => {
                return { error: '服務異常，請再試試看' };
            });
    
    }
);

// GDS Session
export const setGDSSessionData = ({
    date,
    FormatID,
    ETID,
    context,
    dispatch,
}: ISetGDSSessionData) => {
    const sessionurl = getEnvConfig().GDS.session;
    const { setGSessionLoading, setGSessionFetchFail, setSession, setSessionPicked } = context;
    dispatch(setGSessionLoading(true));
    try {
        const config = {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
        };
        // &Date=2022/08/01
        const formattedDate = date ? dayjs(date).format('YYYY/MM/DD') : ''; //API 只吃這種格式日期
        // console.log("formattedDate",formattedDate)
        const source = sessionurl + `?FormatID=${FormatID}&ETID=${ETID}&Date=${formattedDate}`;

        fetch(source, config)
            .then((res) => res.json())
            .then((data) => {
                // console.log('fetchGDSSessionData🤷‍♂️', data);
                if (data.Events?.length !== 0) {
                    const lowest = getLowestPriceSession(data.Events);
                    dispatch(setSession(data.Events));
                    dispatch(setSessionPicked(lowest));
                } else {
                    dispatch(setSession(null));
                    dispatch(setSessionPicked(null));
                }
                dispatch(setGSessionLoading(false));
                dispatch(setGSessionFetchFail(false));
            })
            .catch((error) => {
                dispatch(setGSessionFetchFail(true));
                dispatch(setGSessionLoading(false));
                console.error('fetchSessionDataError:', error);
            });
    } catch (e) {
        console.log('error msg', e);
    }
};

//GDS方案選擇以後首次撈的GDSProductItemDetail
export const fetchGDSDetailData = ({
    ETID,
    EarliestBuyDay,
    ExpectedUseDay,
    FormatID,
    isTHSR,
    context,
    dispatch,
}: IfetchGDSDetailData) => {
    const detailurl = getEnvConfig().GDS.detail;
    const {
        GDetailStore,
        setGDetailStore,
        setGDSDetailFetchFail,
        setDetailFetchFailMsg,
        setGDetail,
        setGTempCalendarData,
        setIsGDSDetailLoading,
        setCalendar,
        ThsrRoundType,
        setGSessionLoading,
        setGSessionFetchFail,
        setSession,
        setSessionPicked
    } = context;

    const handleResetDetailLoading = (isFail: boolean, ErrSituation: string | null = null) => {
        // 若有錯誤先設置錯誤狀況訊息
        isFail && dispatch(setDetailFetchFailMsg(ErrSituation));
        dispatch(setGDSDetailFetchFail(isFail));
        dispatch(setIsGDSDetailLoading(false));
    };

    const isExist = GDetailStore?.filter(item => item.listID === FormatID && item.thsrRoundType === ThsrRoundType);

    // 已有打開過的方案明細，直接取用
    if (isExist && isExist.length !== 0) {
        const firstDayInMonth = getEarliestDate(Object.keys((isExist[0].listDetail.CalendarDate)));
        dispatch(setGDSDetailFetchFail(false));
        dispatch(setGDetail(isExist[0].listDetail)); //初始化 detail
        dispatch(setCalendar(
            isExist[0].hasCalendar
                ? firstDayInMonth
                : null
            )); // 更新 GDS.calendar (多品項狀況需使用)
        dispatch(setGTempCalendarData(
            isExist[0].hasCalendar
                ? isExist[0].listDetail.CalendarDate
                : null
            )); //初始化暫存calendar
        !isTHSR && handletBodyFixed(true);
        // console.log("isTHSR",isTHSR)
        if (!ExpectedUseDay) return;
        if (isExist[0].listDetail?.Sessions) {
            // 判斷不是高鐵GDS，高鐵GDS場次更新會由高鐵GDS的calendarBlock計算完"最終可使用日期"後再去重打
            if(!isTHSR){
                const props = {
                    date: firstDayInMonth
                          ? firstDayInMonth
                          : null,
                    FormatID,
                    ETID,
                    context: {
                        setGSessionLoading,
                        setGSessionFetchFail,
                        setSession,
                        setSessionPicked,
                    },
                    dispatch,
                };

                setGDSSessionData(props);
            }
        }
        return;
    }

    dispatch(setIsGDSDetailLoading(true));

    try {
        const config = {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
        };
        // &CalenderMonth=2022-06
        const listMonth = dayjs(EarliestBuyDay).format('YYYY-MM')
        // isTHSR判斷改source
        const source = isTHSR
            ? detailurl + `?ETID=${ETID}&FormatID=${FormatID}&ThsrRoundType=${ThsrRoundType}&CalenderMonth=${listMonth}`
            : detailurl + `?ETID=${ETID}&FormatID=${FormatID}&ThsrRoundType=&CalenderMonth=${listMonth}`


        fetch(source, config)
            .then((res) => res.json())
            .then((data) => {
                // console.log('初始的!!清單EarliestBuyDay', EarliestBuyDay);
                console.log('fetchGDSDetailData', data);
                const GDetailStoreCopy = JSON.parse(JSON.stringify(GDetailStore));
                const store = GDetailStoreCopy || [];
                if (store.filter((item) => item.listID === FormatID && item.thsrRoundType === ThsrRoundType).length !== 0) return;
                store.push({ listID: FormatID, listDetail: data, hasCalendar: ExpectedUseDay, thsrRoundType:ThsrRoundType });
                
                const daysArrInMonth = getAllDatesInDetailData(data, 'calendarDate');
                //當該方案需要月曆的時候
                if (ExpectedUseDay) {
                    // 預防廠商回傳空的CalendarDate
                    if(daysArrInMonth.length === 0 && data.NotIncludeDate.length === 0){
                        handleResetDetailLoading(true, 'noCalendarDate');
                        return;
                    }
                    dispatch(setGTempCalendarData(data.CalendarDate));
                }
                if (data?.Sessions) {
                    // 初始一筆資料強制開啟方案所以先打一次場次API
                    // 判斷不是高鐵GDS，高鐵GDS場次更新會由高鐵GDS的calendarBlock計算完"最終可使用日期"後再去重打
                    if(!isTHSR){
                        const props = {
                            date: daysArrInMonth.length !== 0
                                ? getEarliestDate(daysArrInMonth)
                                : null,
                            FormatID,
                            ETID,
                            context: {
                                setGSessionLoading,
                                setGSessionFetchFail,
                                setSession,
                                setSessionPicked,
                            },
                            dispatch,
                        };
                        setGDSSessionData(props);
                    }
                }

                dispatch(setCalendar(
                    ExpectedUseDay 
                        ? getEarliestDate(daysArrInMonth) // 抓可選日期的第一天
                        : null
                )); // 初始化 GDS.calendar(日曆預選)
                dispatch(setGDetail(data));
                dispatch(setGDetailStore(store));
                handleResetDetailLoading(false);
                !isTHSR && handletBodyFixed(true);
            })
            .catch((error) => {
                handleResetDetailLoading(true);
                console.error('fetchGDSdataError:', error);
            });
    } catch (e) {
        handleResetDetailLoading(true);
        console.log('error msg', e);
    }
};

//GDS取得下個月份資料用
export const fetchGDSDetailAnotherMonthData = ({
    ETID,
    ExpectedUseDay,
    FormatID,
    isTHSR,
    context,
    CalenderMonth,
    dispatch,
}) => {
    const detailurl = getEnvConfig().GDS.detail;
    // const detailurl = getEnvConfig().GDS;
    // const env = process.env.NODE_ENV;
    // const isProxyUrl = detailurl.detail.indexOf('activity') !== -1;
    // const shouldUseFakeNextMonth = env === 'development' && !isProxyUrl;
    // const detailPlanUrl = shouldUseFakeNextMonth ? detailurl.detailNextMonth : detailurl.detail;
    const {
        setGDetail,
        GDetailStore,
        ThsrRoundType,
        setGDetailStore,
        setGTempCalendarData,
        setIsGDSDetailLoading,
        setGDSDetailFetchFail,
        setDetailFetchFailMsg,
        setCalendar,
        setIsGDSSessionLoading,
        setGDSSessionFetchFail,
        setSession,
        setSessionPicked,
    } = context;

    //決定call API時的狀態
    const handleResetDetailLoading = (isFail: boolean, ErrSituation: string | null = null) => {
        // 若有錯誤先設置錯誤狀況訊息
        isFail && dispatch(setDetailFetchFailMsg(ErrSituation));
        dispatch(setGDSDetailFetchFail(isFail));
        dispatch(setIsGDSDetailLoading(false));
        dispatch(setIsGDSSessionLoading(false));
    };

    try {
        const config = {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
        };
        const source = isTHSR
            ? detailurl + `?ETID=${ETID}&FormatID=${FormatID}&ThsrRoundType=${ThsrRoundType}&CalenderMonth=${CalenderMonth}`
            : detailurl + `?ETID=${ETID}&FormatID=${FormatID}&ThsrRoundType=&CalenderMonth=${CalenderMonth}`
        console.log('NEW source!!!', source);

        fetch(source, config)
            .then((res) => res.json())
            .then((data) => {
                console.log('原本就存好的GDetailStore', GDetailStore);
                console.log('API回來的初始資料', data);
                const daysArrInMonth = getAllDatesInDetailData(data, 'calendarDate');

                if(daysArrInMonth.length === 0 && data.NotIncludeDate.length === 0){
                    handleResetDetailLoading(true, 'noCalendarDate');
                    return;
                }

                let newStore = [];
                
                // FIXME: 因sonarQube會擋邏輯，所以先註解起來
                // if(GDetailStore) { // 月曆切換月份流程
                    
                    // 2023/04/11 與IT討論，決定改成切換月份都會重打，且部分產品場次不固定，因此取消合併
                    // 判斷formatID相同的產品
                    // const store = JSON.parse(JSON.stringify(
                    //     GDetailStore.filter(item => item.listID === FormatID)[0].listDetail
                    // ));
                    // console.log('深拷貝的GdetailStore', store);

                    // 合併舊資料
                    // CalendarDate
                    // let newCalendarDate = { ...store.CalendarDate, ...data.CalendarDate };
                    // console.log('新融合的newCalendarDate', newCalendarDate);

                    // NotIncludeDate
                    // let newNotIncludeDate = getNotIncludeDateSet(
                    //     store.NotIncludeDate,
                    //     data.NotIncludeDate
                    // );
                    // console.log('新融合的newNotIncludeDate', newNotIncludeDate);

                    // let newCalendarDateCopy = JSON.parse(JSON.stringify(newCalendarDate));
                    // let newNotIncludeDateCopy = JSON.parse(JSON.stringify(newNotIncludeDate));

                    // store.CalendarDate = newCalendarDateCopy;
                    // store.NotIncludeDate = newNotIncludeDateCopy;
                    // data.CalendarDate = newCalendarDateCopy;
                    // data.NotIncludeDate = newNotIncludeDateCopy;

                    // 放入整合store
                    // newStore.push({ listID: FormatID, listDetail: store, hasCalendar: ExpectedUseDay });
                    
                    // FIXME: 因sonarQube會擋邏輯，所以先註解起來
                    // newStore.push({ listID: FormatID, listDetail: data, hasCalendar: ExpectedUseDay });
                // } else {
                    // 第一次打API，最早可購買日跨月流程
                    // 放入整合store
                    // FIXME: 因sonarQube會擋邏輯，所以先註解起來
                    // newStore.push({ listID: FormatID, listDetail: data, hasCalendar: ExpectedUseDay });
                // }

                // TODO: 因sonarQube會擋邏輯，所以待之後確認完上面的判斷式後，再把這行給刪掉
                newStore.push({ listID: FormatID, listDetail: data, hasCalendar: ExpectedUseDay, thsrRoundType:ThsrRoundType });

                //當該方案需要月曆的時候
                if (ExpectedUseDay) {
                    dispatch(setGTempCalendarData(data.CalendarDate));
                }

                // 防止連打API 導致回傳為null
                if (typeof data === 'object') {
                    dispatch(setGDetailStore(newStore));
                    console.log("跨月的setCalendar START")
                    dispatch(setCalendar(
                        ExpectedUseDay
                            ? getEarliestDate(daysArrInMonth) // 抓可選日期的第一天
                            : null
                    )); // 初始化 日曆預選
                    dispatch(setGDetail(data));
                    handleResetDetailLoading(false);
                    !isTHSR && handletBodyFixed(true);
                } else {
                    handleResetDetailLoading(true);
                }
                
                /*
                    如果要重打session，要放在setGDetail後，等SessionBlock傳入新的optionData到模組(@magaele/StRcln)後再去打
                    不然會因為切換月份時forSearchPanel.js的 _setDefaultValue 裡的 defValTemp 尚未更新，
                    valueTemp(setSession傳入的) & defValTemp 相比對後無相同的值，導致searchKey為空陣列
                */
                // session重新打一次API
                if (data?.Sessions) {
                    const props = {
                        date: daysArrInMonth.length !== 0
                            ? getEarliestDate(daysArrInMonth)
                            : null,
                        FormatID,
                        ETID,
                        context: {
                            setGSessionLoading: setIsGDSSessionLoading,
                            setGSessionFetchFail:  setGDSSessionFetchFail,
                            setSession,
                            setSessionPicked,
                        },
                        dispatch,
                    };
                    setGDSSessionData(props); 
                }
            })
            .catch((error) => {
                handleResetDetailLoading(true);
                console.error('fetchGDSdataError', error);
            });
    } catch (e) {
        handleResetDetailLoading(true);
        console.log('error msg', e);
    }
};

// TODO: 新版fetch Session API邏輯 待寫

//新版自建方案選擇以後首次撈的ProductItemDetail TODO:未來要融合GDS一起使用
export const fetchDetailData =({
    ETID,
    EarliestBuyDay,
    ExpectedUseDay,
    FormatID,
    isTHSR,
    // DetailFetchMonths,
    context,
    dispatch,
    }: IfetchDetailData) => {
        const detailurl = getEnvConfig().normal.detail;
        const {
            DetailFetchAllData,
            setDetailFetchAllData,
            setDetailLoadingFail,
            setDetailFetchFailMsg,
            setDetailData,
            setTempCalendarData,
            setIsDetailLoading,
            setPickCalendar,
            // setDetailFetchMonths,  
            ThsrRoundType,
            // TODO:第二階段處理
            setIsSessionLoading,
            setSessionLoadingFail,
            setAllSessions,
            setPickSession
        } = context;
        //決定call API時的狀態
        const DetailLoadingStatus = (isFail: boolean, ErrSituation: string | null = null) => {
            // 若有錯誤先設置錯誤狀況訊息
            isFail && dispatch(setDetailFetchFailMsg(ErrSituation));
            dispatch(setDetailLoadingFail(isFail));
            dispatch(setIsDetailLoading(false));
        };

        const isExist = DetailFetchAllData?.filter(item => item.listID === FormatID && item.thsrRoundType === ThsrRoundType);

        // 已有打開過的方案明細，直接取用
        if (isExist && isExist.length !== 0) {
            const firstDayInMonth = getEarliestDate(Object.keys((isExist[0].listDetail.CalendarDate)));
            dispatch(setDetailLoadingFail(false));
            dispatch(setDetailData(isExist[0].listDetail)); //初始化 detail
            dispatch(setPickCalendar(
                isExist[0].hasCalendar
                    ? firstDayInMonth
                    : null
                )); // 更新 calendar (多品項狀況需使用)
            dispatch(setTempCalendarData(
                isExist[0].hasCalendar
                    ? isExist[0].listDetail.CalendarDate
                    : null 
                )); //初始化暫存calendar
            if(!isTHSR) handletBodyFixed(true);
            // console.log("isTHSR",isTHSR)
            if (!ExpectedUseDay) return;
            // TODO: Session 第二階段待判斷
            // if (isExist[0].listDetail?.Sessions) {
            //     // 判斷不是高鐵GDS，高鐵GDS場次更新會由高鐵GDS的calendarBlock計算完"最終可使用日期"後再去重打
            //     if(!isTHSR){
            //         const props = {
            //             date: firstDayInMonth
            //                   ? firstDayInMonth
            //                   : null,
            //             FormatID,
            //             ETID,
            //             context: {
            //                 setGSessionLoading,
            //                 setGSessionFetchFail,
            //                 setSession,
            //                 setSessionPicked,
            //             },
            //             dispatch,
            //         };
            //         setGDSSessionData(props);
            //     }
            // }
            return;
        }

        dispatch(setIsDetailLoading(true));

        try {
            const config = {
                method: 'GET',
                headers: new Headers({
                    'Content-Type': 'application/json',
                }),
            };
            // &CalenderMonth=2022-06
            const listMonth = dayjs(EarliestBuyDay).format('YYYY-MM')
            // isTHSR判斷改source
            const source =  isTHSR
                ? detailurl + `?ETID=${ETID}&FormatID=${FormatID}&ThsrRoundType=${ThsrRoundType}&CalenderMonth=${listMonth}`
                : detailurl + `?ETID=${ETID}&FormatID=${FormatID}&ThsrRoundType=&CalenderMonth=${listMonth}`

            console.log("打API!!")
            fetch(source, config)
                .then((res) => res.json())
                .then((data) => {
                    // console.log('初始的!!清單EarliestBuyDay', EarliestBuyDay);
                    console.log('fetchDetailData', data);

                    // 判斷最早可購買日是否跨月，有跨月就要抓取那個月份 
                    if (dayjs(data.EarliestBuyDay).isAfter(dayjs(listMonth), 'month')) {
                        let newMonth = dayjs(data.EarliestBuyDay).format('YYYY-MM');
                        const fetchDetailProps = { 
                            ETID,
                            ExpectedUseDay: ExpectedUseDay,
                            FormatID,
                            isTHSR: false,
                            context: {
                                setDetailData,
                                DetailFetchAllData,
                                ThsrRoundType,
                                setDetailFetchAllData,
                                setTempCalendarData,
                                setIsDetailLoading,
                                setDetailLoadingFail,
                                setDetailFetchFailMsg,
                                // DetailFetchMonths,
                                // setDetailFetchMonths,
                                // 跨月多帶參數
                                setPickCalendar,
                                // TODO: 第二階段處理
                                setIsSessionLoading,
                                setSessionLoadingFail,
                                setAllSessions,
                                setPickSession
                            },
                            //帶入月份
                            CalenderMonth: newMonth,
                            dispatch,
                        };
                        fetchAnotherMonthData(fetchDetailProps);
                        return;
                    }

                    const DetailFetchAllDataCopy = JSON.parse(JSON.stringify(DetailFetchAllData));
                    const store = DetailFetchAllDataCopy || [];
                    if (store.filter((item) => item.listID === FormatID && item.thsrRoundType === ThsrRoundType).length !== 0) return;
                    store.push({ listID: FormatID, listDetail: data, hasCalendar: ExpectedUseDay, thsrRoundType:ThsrRoundType});

                    const daysArrInMonth = getAllDatesInDetailData(data, 'calendarDate');
                    //當該方案需要月曆的時候
                    if (ExpectedUseDay) {
                        // 可能會回傳空的CalendarDate
                        if(daysArrInMonth.length === 0 && data.NotIncludeDate.length === 0){
                            DetailLoadingStatus(true, 'noCalendarDate');
                            return;
                        }
                        dispatch(setTempCalendarData(data.CalendarDate));
                        /*
                        // 2023/04/11 與IT討論，決定改成切換月份都會重打，並且detail API -> EarliestBuyDay改成固定
                        // 新增當前API月份到切換月份陣列
                        let newObj;
                        if(data.EarliestBuyDay){
                            let date = dayjs(data.EarliestBuyDay).format('YYYY-MM'); 
                
                            if(!!DetailFetchMonths[FormatID]){
                                if(DetailFetchMonths[FormatID].findIndex((month) => month === date) < 0){
                                    newObj = JSON.parse(JSON.stringify(DetailFetchMonths));
                                    newObj[FormatID].push(date);
                                    dispatch(setDetailFetchMonths(newObj));
                                }
                            }else{
                                // 新品項
                                let arr = [ date ];
                                let newObj = { [FormatID] : arr }

                                Object.keys(DetailFetchMonths).length !== 0 //原本是否有其他品項(ID)
                                    ? dispatch(setDetailFetchMonths({ ...DetailFetchMonths, ...newObj }))
                                    : dispatch(setDetailFetchMonths(newObj))
                            }
                        }
                        */
                    }

                    /* TODO: 待第三階段執行
                    if (data?.Sessions) {
                        // 初始一筆資料強制開啟方案所以先打一次場次API
                        // 判斷不是高鐵GDS，高鐵GDS場次更新會由高鐵GDS的calendarBlock計算完"最終可使用日期"後再去重打
                        if(!isTHSR){
                            const props = {
                                date: daysArrInMonth.length !== 0
                                    ? getEarliestDate(daysArrInMonth)
                                    : null,
                                FormatID,
                                ETID,
                                context: {
                                    setGSessionLoading,
                                    setGSessionFetchFail,
                                    setSession,
                                    setSessionPicked,
                                },
                                dispatch,
                            };
                            setGDSSessionData(props);
                        }
                    }
                    */

                    console.log("setPickCalendar!!", getEarliestDate(daysArrInMonth))
                    dispatch(setPickCalendar(
                        ExpectedUseDay 
                            ? getEarliestDate(daysArrInMonth)
                            : null
                    )); // 初始化 日曆預選
                    console.log("setDetailData!!")
                    dispatch(setDetailData(data));
                    console.log("setDetailFetchAllData!!")
                    dispatch(setDetailFetchAllData(store));
                    DetailLoadingStatus(false);
                    !isTHSR && handletBodyFixed(true);
                    console.log("---第一次API結束---")
                })
                .catch((error) => {
                    DetailLoadingStatus(true);
                    console.error('fetchDataError:', error);
                });
        } catch (e) {
            DetailLoadingStatus(true);
            console.log('error msg', e);
        }
};

// 自建取得下個月份資料用，目前只有無高鐵面板(包含Default面板)會使用到此方法
export const fetchAnotherMonthData = ({ 
    ETID,
    ExpectedUseDay,
    FormatID,
    isTHSR,
    context, 
    CalenderMonth,
    dispatch
}) => {
    const normalUrl = getEnvConfig().normal;
    const env = process.env.NODE_ENV;
    const isProxyUrl = normalUrl.detail.indexOf('activity') !== -1;
    const shouldUseFakeNextMonth = env === 'development' && !isProxyUrl;
    const detailUrl = shouldUseFakeNextMonth ? normalUrl.detailNextMonth : normalUrl.detail;
    const { 
        setDetailData,
        DetailFetchAllData,
        ThsrRoundType,
        setDetailFetchAllData,
        setTempCalendarData,
        setIsDetailLoading,
        setDetailLoadingFail,
        setDetailFetchFailMsg,
        // DetailFetchMonths,
        // setDetailFetchMonths,
        // 跨月多帶參數
        setPickCalendar,
        // TODO: 第二階段處理
        setIsSessionLoading,
        setSessionLoadingFail,
        setAllSessions,
        setPickSession
    } = context;

    //決定call API時的狀態
    const DetailLoadingStatus = (isFail: boolean, ErrSituation: string | null = null) => {
        // 若有錯誤先設置錯誤狀況訊息
        isFail && dispatch(setDetailFetchFailMsg(ErrSituation));
        dispatch(setDetailLoadingFail(isFail));
        dispatch(setIsDetailLoading(false));
        dispatch(setIsSessionLoading(false));
    };

    try {
        const config = {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
            }),
        };
        const source = isTHSR
                ? detailUrl + `?ETID=${ETID}&FormatID=${FormatID}&ThsrRoundType=${ThsrRoundType}&CalenderMonth=${CalenderMonth}`
                : detailUrl + `?ETID=${ETID}&FormatID=${FormatID}&ThsrRoundType=&CalenderMonth=${CalenderMonth}`

        fetch(source, config)
            .then((res) => res.json())
            .then((data) => {
                console.log('原本就存好的AllData', DetailFetchAllData);
                console.log('API回來的初始資料', data);
                const daysArrInMonth = getAllDatesInDetailData(data, 'calendarDate');

                if(typeof data !== 'object' || (daysArrInMonth.length === 0 && data.NotIncludeDate.length === 0)){ // 防止連打API，導致回傳為null
                    DetailLoadingStatus(true, daysArrInMonth.length === 0 ? 'noCalendarDate' : null);
                    return;
                }

                let newStore = [];

                if(DetailFetchAllData) { // 月曆切換月份流程
                    /* 
                    // 2023/04/11 與IT討論，決定改成切換月份都會重打，且部分產品場次不固定，因此取消合併
                    // 判斷formatID&ThsrRoundType相同的產品
                    const store = JSON.parse(JSON.stringify(
                        DetailFetchAllData.filter(item => item.listID === FormatID && item.thsrRoundType === ThsrRoundType)[0].listDetail
                    ));

                    // 合併舊資料
                    // CalendarDate
                    let newCalendarDate = { ...store.CalendarDate, ...data.CalendarDate };

                    // NotIncludeDate
                    let newNotIncludeDate = getNotIncludeDateSet(
                        store.NotIncludeDate,
                        data.NotIncludeDate
                    );

                    let newCalendarDateCopy = JSON.parse(JSON.stringify(newCalendarDate));
                    let newNotIncludeDateCopy = JSON.parse(JSON.stringify(newNotIncludeDate));

                    store.CalendarDate = newCalendarDateCopy;
                    store.NotIncludeDate = newNotIncludeDateCopy;
                    data.CalendarDate = newCalendarDateCopy;
                    data.NotIncludeDate = newNotIncludeDateCopy;
                    
                    // 放入整合store
                    newStore.push({ listID: FormatID, listDetail: store, hasCalendar: ExpectedUseDay, thsrRoundType:ThsrRoundType });
                    */
                    newStore.push({ listID: FormatID, listDetail: data, hasCalendar: ExpectedUseDay,thsrRoundType:ThsrRoundType });

                } else {
                    // 第一次打API，最早可購買日跨月流程
                    // 放入整合store
                    newStore.push({ listID: FormatID, listDetail: data, hasCalendar: ExpectedUseDay,thsrRoundType:ThsrRoundType });
                }

                //當該方案需要月曆的時候
                if (ExpectedUseDay) {
                    dispatch(setTempCalendarData(data.CalendarDate));
                    /*
                    // 2023/04/11 與IT討論，決定改成切換月份都會重打，並且detail API -> EarliestBuyDay改成固定
                    // 新增當前API月份到切換月份陣列
                    let newObj;
                    if(data.EarliestBuyDay){
                        let date = dayjs(data.EarliestBuyDay).format('YYYY-MM'); 
                    
                        if(!!DetailFetchMonths[FormatID]){
                            if(DetailFetchMonths[FormatID].findIndex((month) => month === date) < 0){
                                newObj = JSON.parse(JSON.stringify(DetailFetchMonths));
                                newObj[FormatID].push(date);
                                dispatch(setDetailFetchMonths(newObj));
                            }
                        }else{
                            // 新品項
                            let arr = [ date ];
                            newObj = { [FormatID] : arr }

                            Object.keys(DetailFetchMonths).length !== 0 //原本是否有其他月份
                                ? dispatch(setDetailFetchMonths({ ...DetailFetchMonths, ...newObj }))
                                : dispatch(setDetailFetchMonths(newObj))
                        }
                    }
                    */
                }

                dispatch(setDetailFetchAllData(newStore));
                dispatch(setPickCalendar(
                    ExpectedUseDay
                        ? getEarliestDate(daysArrInMonth) // 抓可選日期的第一天
                        : null
                )); // 初始化 日曆預選
                dispatch(setDetailData(data));
                DetailLoadingStatus(false);
                !(DetailFetchAllData == null) && !isTHSR && handletBodyFixed(true);
               
                /*  TODO: 第二階段處理
                    如果要重打session，要放在setDetailData後，等SessionBlock傳入新的optionData到模組(@magaele/StRcln)後再去打
                    不然會因為切換月份時forSearchPanel.js的 _setDefaultValue 裡的 defValTemp 尚未更新，
                    valueTemp(setSession傳入的) & defValTemp 相比對後無相同的值，導致searchKey為空陣列
                    ***GDS情況 自建待查證***
              
                // session重新打一次API
                if (data?.Sessions) {
                    const props = {
                        date: daysArrInMonth.length !== 0
                            ? getEarliestDate(daysArrInMonth)
                            : null,
                        FormatID,
                        ETID,
                        context: {
                            setGSessionLoading: setIsGDSSessionLoading,
                            setGSessionFetchFail:  setGDSSessionFetchFail,
                            setSession,
                            setSessionPicked,
                        },
                        dispatch,
                    };
                    setGDSSessionData(props);
                }
                */
            })
            .catch((error) => {
                DetailLoadingStatus(true);
                console.log('fetchNormalDataError', error);
            });
    } catch (e) {
        DetailLoadingStatus(true);
        console.log('error msg', e);
    }
};

// 自建THSR跨月 打API回傳promise當月並合併原本月份(除了 condition1 是直接覆蓋)
export const fetchNextMonthData = ({ CalenderMonth, ETID, FormatID, ThsrRoundType }) => {
    console.log("高鐵跨月API START")
    const normalUrl = getEnvConfig().normal;
    const detailUrl = normalUrl.detail;
    const source =  
        ThsrRoundType !== null
            ? detailUrl + `?ETID=${ETID}&FormatID=${FormatID}&ThsrRoundType=${ThsrRoundType}&CalenderMonth=${CalenderMonth}`
            : detailUrl + `?ETID=${ETID}&FormatID=${FormatID}&ThsrRoundType=&CalenderMonth=${CalenderMonth}`
    const config = {
        method: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
    };
    return fetch(source, config);
};

// 自建以及GDS Fetch lightbox data
export const fetchLightBoxData = () => {
    const normalUrl = getEnvConfig().COMMON;
    const lightboxUrl = normalUrl.lightbox;
    // const source =  
    //     ThsrRoundType !== null
    //         ? detailUrl + `?ETID=${ETID}&FormatID=${FormatID}&ThsrRoundType=${ThsrRoundType}&CalenderMonth=${CalenderMonth}`
    //         : detailUrl + `?ETID=${ETID}&FormatID=${FormatID}&ThsrRoundType=&CalenderMonth=${CalenderMonth}`
    const source = lightboxUrl;
    const config = {
        medthod: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
    };
    return fetch(source, config);
};

// 送出訂單前驗證商品購買數量上下限在當時是否有調整
export const fetchProductOrderValidity = (
    productCode: string,
    productDetailOrder: string,
    ProductUseDate: string
) => {
    const VerificationUrl = getEnvConfig().COMMON.OrderValidation;
    const source =
        VerificationUrl +
        `?ProductCode=${productCode}&ProductDetailOrder=${productDetailOrder}&ProductUseDate=${ProductUseDate}`;
    const config = {
        medthod: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
    };
    return fetch(source, config);
};

// 方案説明 API
export const fetchProductItemDesc = (ETID: string, FormatID: string, Key?: string) => {
    const productItemDescUrl = getEnvConfig().COMMON.productItemDesc;
    const source = productItemDescUrl + `?ETID=${ETID}&FormatID=${FormatID}` + (Key ? `&Key=${Key}` : '');
    const config = {
        medthod: 'GET',
        headers: new Headers({
            'Content-Type': 'application/json',
        }),
    };
    return fetch(source, config);
}